// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import Link from "@insite/mobius/Link";
import { domToReact, HTMLReactParserOptions } from "html-react-parser";
import React from "react";

export const createParserOptions = (
    onLinkClick: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void,
): HTMLReactParserOptions => ({
    replace: node => {
        const { name, children, attribs = { style: "" } } = node;
        const { style, class: className, ...otherAttribs } = attribs;

        otherAttribs.className = className;

        if (name === "a") {
            let onClickHandler: ((event: React.MouseEvent<HTMLElement, MouseEvent>) => void) | undefined;
            for (const key in otherAttribs) {
                if (key === "ng-click") {
                    onClickHandler = onLinkClick;
                }
            }
            return (
                <Link
                    css={style as any}
                    id={otherAttribs.name}
                    {...otherAttribs}
                    onClick={(event: React.MouseEvent<HTMLElement, MouseEvent>) =>
                        onClickHandler && onClickHandler(event)
                    }
                >
                    {children && domToReact(children, parserOptions)}
                </Link>
            );
        }
    },
});
